{
  "name": "novus-web",
  "version": "0.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration development",
    "build": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build",
    "build:dev": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration development",
    "build:rel": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration release-candidate",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "e2e": "ng e2e",
    "lint": "ng lint",
    "extract-i18n": "ng extract-i18n --output-path src/locale"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "flag-icons": "^7.5.0",
    "flatpickr": "^4.6.13",
    "libphonenumber-js": "^1.12.40",
    "lodash": "^4.18.1",
    "ol": "^10.8.0",
    "particles.js": "^2.0.0",
    "plotly.js-dist-min": "^3.5.0",
    "rxjs": "^7.6.0",
    "tabulator-tables": "^6.5.2",
    "three": "^0.183.1",
    "tslib": "^2.3.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.2.0",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/schematics": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.5",
    "@angular/localize": "^21.1.5",
    "@playwright/test": "^1.58.2",
    "@types/flatpickr": "^3.0.2",
    "@types/lodash": "^4.17.24",
    "@types/node": "^25.3.0",
    "@types/plotly.js-dist-min": "^2.3.4",
    "@types/tabulator-tables": "^6.3.6",
    "@types/three": "^0.183.1",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "eslint": "^8.57.1",
    "jsdom": "^28.1.0",
    "typescript": "~5.9.3",
    "vitest": "^4.0.18"
  }
}
